import AccountDetailsForm from './accountDetailsForm';

export default AccountDetailsForm;
